import { render, staticRenderFns } from "./about_nongye.vue?vue&type=template&id=9e4e5d3c&"
import script from "./about_nongye.vue?vue&type=script&lang=js&"
export * from "./about_nongye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports